import { NumberInput, TextInput } from "@msuite/ui/form";
import { useTranslation } from "@msuite/ui/localization";
import type { VendorArticleFormSchema } from "@msuite/utils/schemas";
import { useFormContext } from "react-hook-form";
import { ContactPicker } from "@/components/contacts";

export function VendorArticleForm() {
	/** Context */
	const methods = useFormContext<VendorArticleFormSchema>();

	/** Hooks */
	const { t } = useTranslation();

	/** Render */
	return (
		<div className="v-stack gap-4">
			<ContactPicker
				control={methods.control}
				name="contactId"
				label={t("stock.vendor")}
				isNullable={false}
			/>
			<TextInput
				isRequired
				control={methods.control}
				name="identifier"
				label={t("stock.vendor_article_number")}
				placeholder={t("placeholders.stock.vendor_article_number")}
			/>
			<NumberInput
				min={0}
				variant="currency"
				isRequired
				control={methods.control}
				name="purchasePrice"
				label={t("stock.purchase_price")}
				placeholder="0"
				step={0.01}
			/>
		</div>
	);
}
